module.exports = __webpack_public_path__ + "de6bc85e88c513921f52cc8e29d16871.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/phonecase-blank.png
// module id = 794
// module chunks = 0